import envConfig from '../../../../next-server/lib/runtime-config'
import { resolveGlobalConfig } from './lib/resolveGlobalConfig'
import { wrapApp } from './lib/wrapApp'
import { checkProcessEnv } from '../../helper/process-env-universal'

export function extendsApp(App, createGlobalConfig) {
  checkProcessEnv()

  if (!createGlobalConfig) {
    throw new Error('未正确在 _app 上提供 globalConfig')
  }

  const {
    serverRuntimeConfig,
    publicRuntimeConfig: runtimeConfig,
  } = envConfig()

  // 业务工程手动指定目标工作模式为 export，便于控制开发期的代码行为(开发期按ssr/export工作)
  // 业务工程声明 mode === 'export' 时，开发运行时、build、export，isExportMode 均为 true
  // 业务工程声明 mode === 'ssr' 时，开发运行时、build，isExportMode 为 false，export 时为 true
  // 以 ssr 运行时，__NEXT_DATA__ 动态生成无影响；以 export 运行时，__NEXT_DATA__ 硬编码到 html 上
  const isExportMode =
    runtimeConfig.frameworkConfig.mode === 'export' ||
    runtimeConfig.frameworkConfig.isGeneratedByExport

  // TODO 打印全局的状态，isExportMode 应分离到 server，其实质是全局常量
  if (process.server) {
    process.nextTick(() => {
      console.log(
        [
          '',
          `-------- ENV(pid: ${process.pid}) --------`,
          `isExportMode: ${JSON.stringify(isExportMode)}`,
          '--------------------------------',
        ].join('\n')
      )
    })
  }

  const globalConfig = resolveGlobalConfig(createGlobalConfig, {
    runtimeConfig,
    serverRuntimeConfig,
  })

  // 包装 withXxx
  const TargetApp = wrapApp(App, {
    isExportMode,
    globalConfig,
    serverRuntimeConfig,
    runtimeConfig,
  })
  TargetApp.globalConfig = globalConfig

  // 添加标记，用于检测是否业务工程 App 是否已经过 withApp 包装
  TargetApp.__AL_EX_IDENTITY_aJOfQuWBzXOpO7jQ =
    'fa268946-7d55-41dd-b383-526a828ac74a'

  return TargetApp
}
